import axios from 'axios'

export const urls = {
  payments: 'api/users',
}

export const trackPaymentActivity = (data, userToken) => {
  return axios.post(`${urls.payments}/package-views-activity`, data, {
    headers: {
      Authorization: `Bearer ${userToken}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
}
